export const GAME_WIDTH = 1920;
export const GAME_HEIGHT = 1080;
